import "core-js/modules/es6.symbol";
import "core-js/modules/es6.array.index-of";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
/* eslint-disable camelcase */


var YouKuVideo =
/** @class */
function () {
  function YouKuVideo(idStr, _a) {
    var options = __rest(_a, []);

    this.API_URL = 'https://player.youku.com/jsapi';
    this.idStr = idStr;
    this.client_id = options.client_id;
    this.vid = options.vid;
    this.autoplay = options.autoplay || false;
    this.show_related = options.show_related || false;
    this.init();
  }

  YouKuVideo.prototype.init = function () {
    this.creatVideo();
  };

  YouKuVideo.prototype.creatVideo = function () {
    // eslint-disable-next-line
    var _a = this,
        idStr = _a.idStr,
        client_id = _a.client_id,
        vid = _a.vid,
        API_URL = _a.API_URL,
        autoplay = _a.autoplay,
        show_related = _a.show_related;

    var scriptDom = document.createElement('script');
    scriptDom.src = API_URL;
    document.head.append(scriptDom);
    scriptDom.addEventListener('load', function () {
      // eslint-disable-next-line no-undef, no-unused-vars
      var player = new YKU.Player(idStr, {
        styleid: '0',
        client_id: client_id,
        vid: vid,
        autoplay: autoplay,
        show_related: show_related
      });
    });
  };

  return YouKuVideo;
}();

export default YouKuVideo;